import moment from 'moment'

export const setUser = (user) => {
  return {
    type: 'SET_USER',
    user: user
  }
}

export const setToken = (token) => {
  return {
    type: 'SET_TOKEN',
    token: token
  }
}

export const logUser = (login) => {
  return {
    type: 'LOG_USER',
    login
  }
}

export const setUserAttribute = (attribute) => {
  return {
    type: 'SET_USER_ATTRIBUTE',
    attribute
  }
}

export const setLoading = (loading) => {
  return {
    type: 'SET_LOADING',
    loading
  }
}

export const setNumberOfNewPosts = (numberOfNewPosts) => {
  return {
    type: 'SET_NUMBER_OF_NEW_POSTS',
    numberOfNewPosts
  }
}

export const setDateOfLastReading = (dateOfLastReading) => {
  return {
    type: 'SET_DATE_OF_LAST_READING',
    dateOfLastReading
  }
}

export const showModal = () => {
  return {
    type: 'SHOW_MODAL'
  }
}

export const hideModal = () => {
  return {
    type: 'HIDE_MODAL'
  }
}

export const setSubgroupItems = (subgroupItems) => {
  return {
    type: 'SET_SUBGROUP_ITEMS',
    subgroupItems
  }
}

export const setProductsLastFetch = (lastFetch) => {
  return {
    type: 'SET_PRODUCTS_LAST_FETCH',
    lastFetch
  }
}

export const setCart = (cart) => {
  return {
    type: 'SET_CART',
    cart
  }
}

export const setPayerInfo = (payerInfo) => {
  return {
    type: 'SET_PAYER_INFO',
    payerInfo
  }
}

export const setDeliveryAddress = (deliveryAddress) => {
  return {
    type: 'SET_DELIVERY_ADDRESS',
    deliveryAddress
  }
}

export const setOrders = (orders) => {
  return {
    type: 'SET_ORDERS',
    orders
  }
}

export const setIsAppBlocked = blockStatusResponse => {
  const isAppBlocked = blockStatusResponse.status === 'blocked'

  return {
    type: 'SET_IS_APP_BLOCKED',
    isAppBlocked
  }
}

export const setPendingBillings = billingList => {
  const billingListWithStatus = billingList.map(billing => {
    const daysAfterDueDate = moment().diff(moment(billing.dueDate, 'YYYY-MM-DD'), 'days')
    const wasPaid = billing.serviceOrder.find(order => order.status === 'paid')
    const wasCreated = billing.serviceOrder.find(order => order.status === 'created')
    const wasRefunded = billing.serviceOrder.find(order => order.status === 'refunded')
    const status = billing.isCanceled ? 'canceled'
      : wasPaid ? 'paid'
        : wasCreated ? 'created'
          : wasRefunded ? 'refunded'
            : daysAfterDueDate > 0 ? 'late'
              : 'awaitingPayment'

    return {
      ...billing,
      status
    }
  })

  const pendingBillings = billingListWithStatus.filter(billing => {
    return billing.status === 'awaitingPayment'
  })

  return {
    type: 'SET_PENDING_BILLINGS',
    pendingBillings
  }
}

export const setAllBillings = allBillings => {
  const billingListWithStatus = allBillings.map(billing => {
    const daysAfterDueDate = moment().diff(moment(billing.dueDate, 'YYYY-MM-DD'), 'days')
    const wasPaid = billing.serviceOrder.find(order => order.status === 'paid')
    const wasCreated = billing.serviceOrder.find(order => order.status === 'created')
    const wasRefunded = billing.serviceOrder.find(order => order.status === 'refunded')
    const status = billing.isCanceled ? 'canceled'
      : wasPaid ? 'paid'
        : wasCreated ? 'created'
          : wasRefunded ? 'refunded'
            : daysAfterDueDate > 0 ? 'late'
              : 'awaitingPayment'

    return {
      ...billing,
      status,
      installments: wasPaid ? wasPaid.installments : undefined
    }
  })

  return {
    type: 'SET_ALL_BILLINGS',
    allBillings: billingListWithStatus
  }
}

export const setCurrentRoute = currentRoute => {
  return {
    type: 'SET_CURRENT_ROUTE',
    currentRoute
  }
}

export const setHistoryPush = historyPush => {
  return {
    type: 'SET_HISTORY_PUSH',
    historyPush
  }
}

export const setFetchedInLogin = fetchedInLogin => {
  return {
    type: 'SET_FETCHED_IN_LOGIN',
    fetchedInLogin
  }
}



// WEBPACK FOOTER //
// ./src/redux/actions.js